module.exports = __webpack_public_path__ + "img/athletics_icon_9.09ea10ac.png";